import { useQueryClient } from '@tanstack/react-query';
import { getValidateOrderProductsKey } from '../../../services/modules/order-product/order-product.keys';
import {
  OrderProductsWithErrors,
  ValidateOrderProductsOutput,
} from '../../../services/modules/order-product/order-product.types';
import { useApplicationContext } from '../../context/ApplicationContext/ApplicationContext';

const useLatestOrderProductsWithErrors = (orderId: string) => {
  const queryClient = useQueryClient();
  const { team } = useApplicationContext();

  const getLatestOrderProductsWithErrors = (fallback: OrderProductsWithErrors) => {
    const validation = queryClient.getQueryData<ValidateOrderProductsOutput | null>([
      team?.id,
      ...getValidateOrderProductsKey({ orderId }),
    ]);

    return validation?.orderProductsWithErrors ?? fallback;
  };

  return { getLatestOrderProductsWithErrors };
};

export default useLatestOrderProductsWithErrors;
